
const AboutUs = () => {

	return(
		<div className="about-section">
		<p>This app was developed by solomon chiakonam, a junior fullstack developer also known as Associate Developer,
		 He is a senior fullstack engineer at <a href="https://codeblazeacademy.com" target="_blank">codeblaze academy</a>
		 </p>
		</div>
		);
}
export default AboutUs;